import React from 'react';

import { FormControlLabel, Radio } from '@mui/material';

export const RadioButton = ({ label, value }: Props) => (
  <FormControlLabel label={label} value={value} control={<Radio size="small" />} />
);

interface Props {
  readonly label: string;
  readonly value: string;
}
